const PENDING_KEY = 'gaga:quiz_pending_score'

export const QUIZ_ID = 'mie-ayam-squad'

export type PendingQuizScore = {
	quizId: string
	correct: number
	wrong: number
	total: number
	completedAt: string
	locale: string
}

export const setPendingQuizScore = (score: PendingQuizScore): void => {
	sessionStorage.setItem(PENDING_KEY, JSON.stringify(score))
}

export const getPendingQuizScore = (): PendingQuizScore | null => {
	try {
		const raw = sessionStorage.getItem(PENDING_KEY)
		if (!raw) return null
		return JSON.parse(raw) as PendingQuizScore
	} catch {
		return null
	}
}

export const clearPendingQuizScore = (): void => {
	sessionStorage.removeItem(PENDING_KEY)
}
